export default "__VITE_ASSET__BvALlrdK__"